import {bizFeesOtherNumber} from "../app";

function BizTextInsert () {
  const bizFeesOther = document.querySelectorAll("[data-string='bizFeesOther']")
  bizFeesOther?.forEach(str => {
    str.textContent = `${bizFeesOtherNumber}`
  });
}
export {BizTextInsert}